import React from 'react';
import { Link } from 'react-router';
import PropTypes from 'prop-types';

const NextLink = ({ to, onNextClick }) => (
  <div className="u-text-center u-mt+ ">
    <Link to={to} className="c-btn c-btn--primary u-ph++" onClick={onNextClick}>
      Next
    </Link>
  </div>
);
NextLink.propTypes = {
  to: PropTypes.string,
  onNextClick: PropTypes.func,
};
NextLink.defaultProps = {
  to: '',
  onNextClick: () => true,
};

export default NextLink;



// WEBPACK FOOTER //
// ./src/app/components/NextLink.jsx